module.exports = __webpack_public_path__ + "static/media/hp-login-banner-@2x.f15b0758.jpg";